// components/Footer.js
// components/Footer.js
import { FaInstagram, FaFacebook, FaTwitter, FaTiktok, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black py-6 w-full">
      <div className="container mx-auto flex flex-col md:flex-row items-center relative">
        {/* Título centralizado */}
        <div className="text-marfim text-xl uppercase leading-10 tracking-widest mb-6 md:mb-0 absolute inset-x-0 text-center" style={{ letterSpacing: "10px" }}>
          {process.env.TITLE}<br />
          <p className="text-xs leading-tight tracking-tighter">- Copyright ® 2025 - Todos os Direitos Reservados.</p>
          <p className="text-xs leading-tight tracking-tighter">Contato: {process.env.NEXT_PUBLIC_PHONE_NUMBER}</p>
        </div>

        {/* Redes sociais no rodapé (sem rolar com a página) */}
        <div className="flex space-x-2  bottom-4 right-4 z-10 p-2">
          {process.env.INSTAGRAM && (
            <a href={process.env.INSTAGRAM} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1">
              <div className="p-2 bg-red-500 text-white rounded cursor-pointer">
                <FaInstagram size={20} />
              </div>
            </a>
          )}
          {process.env.FACEBOOK && (
            <a href={process.env.FACEBOOK} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1">
              <div className="p-2 bg-red-500 text-white rounded cursor-pointer">
                <FaFacebook size={20} />
              </div>
            </a>
          )}
          {process.env.TWITTER && (
            <a href={process.env.TWITTER} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1">
              <div className="p-2 bg-red-500 text-white rounded cursor-pointer">
                <FaTwitter size={20} />
              </div>
            </a>
          )}
          {process.env.LINKEDIN && (
            <a href={process.env.LINKEDIN} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1">
              <div className="p-2 bg-red-500 text-white rounded cursor-pointer">
                <FaLinkedinIn size={20} />
              </div>
            </a>
          )}
          {process.env.TIKTOK && (
            <a href={process.env.TIKTOK} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1">
              <div className="p-2 bg-red-500 text-white rounded cursor-pointer">
                <FaTiktok size={20} />
              </div>
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;


